import { PluginKey } from '@tiptap/pm/state';
import { Node_Type } from 'ricos-types';

const collapsibleModals = {
  settings: `${Node_Type.COLLAPSIBLE_LIST}.settings`
};
const collapsibleStateManagerPlugin = new PluginKey("collapsibleStateManager");

export { collapsibleModals, collapsibleStateManagerPlugin };
//# sourceMappingURL=consts.js.map
